/* Speichern aus dem Editor heraus: Download-Dienst der Umgebung (falls vorhanden), sonst Kopieren/Anzeigen im Dialog. */
export interface Downloads { save(o: { filename: string; data: string | Blob | Uint8Array }): Promise<unknown> }

/** Download-Dienst der Umgebung, oder null (normaler Browser) */
export async function getDownloads(): Promise<Downloads | null> {
  try {
    const c = (window as unknown as { claude?: { use?: (n: string) => Promise<Downloads> } }).claude;
    return c && c.use ? await c.use('downloads') : null;
  } catch (err) { return null; }
}

/** Dateiname ohne Sonderzeichen */
export const safeName = (name: string | undefined | null, dflt = 'map'): string => (name || dflt).replace(/[^\w-]+/g, '_');

/** Fehlercode eines abgelehnten oder fehlgeschlagenen Speicherns */
export const errCode = (err: unknown): string | undefined => (err && typeof err === 'object' && 'code' in err ? String((err as { code: unknown }).code) : undefined);
